import { t } from "i18next";
import React from "react";
import {
  ACTIONS,
  AuthRoutes,
  APIs,
  USERTYPES,
} from "../../../constants/Constants";
import { StringLiterals } from "../../../constants/StringLiterals";
import { getEnv } from '../../../helpers/EnvHelper';
import { CXR_TRIAGE_MIN_AGE } from "./CxrTriageMinAge";

export const InitialData = (firmType, firmRole, role, action, isVdcPlatform) => ({
  name: "",
  code: "",
  address: "",
  country: "India",
  state: "",
  city: "",
  active: false,
  customerSupportNumber:"",
  customerSupportNumberCountryCode:"",
  customerSupportNumberDialCode:"",
  firmType: firmType != null ? firmType : "Hospital",
  firmRole: firmRole != null ? firmRole : null,
  password_protected: false,
  triageCTStudies: false,
  triageXRAYStudies: true,
  addTimeToReport: false,
  addDateToReport: true,
  addSupervisorSignature: false,
  enableQualityModel: false,
  compressStudyDownload: false,
  demoFirm: false,
  demoExpiryType: null,
  demoExpiryDate: null,
  maxStudyUploads: null,
  demoStudyCount: null,
  watermarkImage: null,
  watermarkImageUrl: null,
  isWatermarkImageDeleted: 0,
  watermarkOpacity: 100,
  watermarkWidth: 100,
  watermarkRotation: 0,
  isDOC: false,
  isDOCX: false,
  isPDF: false,
  isPDFWithImage: false,
  isPDFWithKeyImage: false,
  isDOCXWithKeyImage: false,
  qcEnabled: false,
  preliminaryQcEnabled: false,
  // headerImage: null,
  masterStudyReportId: null,
  twoSignaturesAllowed: false,
  enableQCAutoAssignment: false,
  modalityIds: [],
  reportHeaderDto: {
    headerImage: null,
    footerImage: null,
    headerImageUrl: null,
    footerImageUrl: null,
    isHeaderImageDeleted: null,
    isFooterImageDeleted: null,
  },
  signature2Dto: {
    signatureFile2: null,
    signature2Text: null,
    signatureImageUrl: "",
    isSignatureImageDeleted: null
  },
  signature3Dto: {
    signatureFile3: null,
    signature2Text: null,
    signatureImageUrl: "",
    isSignatureImageDeleted: null
  },
  contact1: {
    name: "",
    email: "",
    type: "",
    mobile: "",
    landline: "",
  },
  contact2: {
    name: "",
    email: "",
    type: "",
    mobile: "",
    landline: "",
  },
  contact3: {
    name: "",
    email: "",
    type: "",
    mobile: "",
    landline: "",
  },
  // headerFile: null,
  // footerFile: null,
  signature2Text: null,
  signature3Text: null,
  // signatureFile2: null,
  // signatureFile3: null,
  addPrintDisclaimer: false,
  showWord: false,
  printDisclaimerText: "",
  studyLinkExpiryTime: 0,
  enableShareReportLink: false,
  reportLinkExpiryTime: 0,
  reportLeftMarginPt:0,
  reportRightMarginPt:0,
  qrLinkExpiryTime: 0,
  qrLinkMaxExpiryDays: 90,
  accountWarning: "",
  updatedTimeString: null,
  schemeCode: null,
  autoAssignModalityIds: [],
  autoAssignModalityWithSubModalityIds: [],
  autoAssignEnable: false,
  exactMatchEnable: false,
  isClientWarning: false,
  addendumDisclaimerEnabled: false,
  addendumDisclaimerText: "",
  allowDownloadStudy: true,
  allowDownloadReport: true,
  enableQRCodeInReport: false,
  enableStudySharingLinkInReport: false,
  emailPDF: true,
  emailDOCX: false,
  emailDOC: false,
  enableUnassignmentService:false,
  reqBlankLines: 2,
  reqBlankLinesAfterHeader:0,
  headerTextLine1:"",
  headerTextLine2:"",
  externalFirm: false,
  priorityCount: role === USERTYPES.ADMIN ? 0 : 50,
  branchCode: "",
  historyAvailable: false,
  clinicalNoteMandatory: false,
  technicianContactMandatory: isVdcPlatform?true:false,
  historyModalityIds: [],
  radiologistIdList: [],
  supervisorIdList: [],
  pediatricAssignmentEnabled: false,
  selectedPediatricModalityId: [],
  pacsNodeList:[],
  showPriorsStudies: true,
  cxrVersionViewer: false,
  cxrVersionStudyList: false,
  boneEnabled: false,
  showFindings: true,
  showProbability : true,
  cxrTriageMinAge: CXR_TRIAGE_MIN_AGE.DETECT,
  subtleFindings: false,
  showAboveThresholdScore : true,
  enableGenkiStudyInference : true,
  enableSecondaryCapture: false,
  multiframeSplit: true,
  //sendReportSubmitNotification: false,
  sendReportSubmitNotification: role === USERTYPES.FIRMADMIN ,
  enableCriticalAlert: true,
  modalityBuckets: [
    { 
      // modality: action === ACTIONS.ADD ? "DEFAULT" : "", 
       modality: "", 
      bucketConfiguration: "" 
    }
  ],
  enableWhatsApp: false,
  whatsappNumber: "",
  enableEmail: true,
  notificationEmail: "",
  allowFirmAdminSetClientComm: false,
  firmAdminCanEnableWhatsapp: false,
  firmAdminCanEnableEmail: false,
  firmEmailNotify: false,
  firmWhatsappNotify: false,
  firmTimeZone: getEnv("REACT_APP_BACKEND_TIMEZONE"),
});

export const editBreadCrumbItems = (
  state,
  enterprise,
  ownFirm,
  role,
  firmType,
  firmMode
) => {
  if(firmMode==="projects"){
    return [
      {
        text: t("hospital.projects"),
        key: "projects",
        href: AuthRoutes.PROJECTLIST,
      },
      {
        text: t("hospital.project-details"),
        key: "project-details",
      },
    ];
  }
  if (firmType == 1) {
    return [
      {
        text: t("hospital.providers"),
        key: "hospital",
        href: AuthRoutes.PROVIDERLIST,
      },
      {
        text: t("hospital.edit-provider"),
        key: "hospital-details",
      },
    ];
  } else {
    return ownFirm
      ? [
          {
            text: enterprise
              ? t("hospital.edit-hospital")
              : t("hospital.edit-firm"),
            key: "edit-hospital",
          },
        ]
      : [
          {
            text: enterprise
              ? t("hospital.hospitals")
              : role === USERTYPES.ADMIN
              ? t("hospital.firms")
              : t("hospital.clients"),
            key: "hospital",
            href:
              role === USERTYPES.ADMIN
                ? AuthRoutes.FIRMLIST
                : AuthRoutes.CLIENTLIST,
          },
          {
            text: enterprise
              ? t("hospital.hospital-details")
              : role === USERTYPES.ADMIN
              ? t("hospital.edit-firm")
              : t("hospital.edit-client"),
            key: "hospital-details",
          },
        ];
  }
};

export const viewBreadCrumbItems = (
  state,
  enterprise,
  ownFirm,
  role,
  location,
  viewWarningOnly,
  firmType,
  firmMode
) => {
  console.log(firmType)
  if(firmMode==="projects"){
    return [
      {
        text: t("hospital.projects"),
        key: "projects",
        href: AuthRoutes.PROJECTLIST,
      },
      {
        text: t("hospital.project-details"),
        key: "project-details",
      },
    ];
  }
  if (firmType == 1) {
    console.log("inside firm type 1")
    return [
      {
        text: t("hospital.providers"),
        key: "hospital",
        href: AuthRoutes.PROVIDERLIST,
      },
      {
        text: t("hospital.provider-details"),
        key: "hospital-details",
      },
    ];
  } else {
    return ownFirm
      ? [
          {
            text: enterprise
              ? t("hospital.hospital-details")
              : t("hospital.firm-details"),
            key: "hospital-details",
          },
        ]
      : !viewWarningOnly
      ? [
          {
            text: enterprise
              ? t("hospital.hospitals")
              : role === USERTYPES.ADMIN
              ? t("hospital.firms")
              : t("hospital.clients"),
            key: "hospital",
            href:
              role === USERTYPES.ADMIN
                ? AuthRoutes.FIRMLIST
                : AuthRoutes.CLIENTLIST,
          },
          {
            text: enterprise
              ? t("hospital.hospital-details")
              : role === USERTYPES.ADMIN
              ? t("hospital.firm-details")
              : t("hospital.client-details"),
            key: "hospital-details",
          },
        ]
      : [
          {
            text: enterprise
              ? t("hospital.hospital-details")
              : role === USERTYPES.ADMIN
              ? t("hospital.firm-details")
              : t("hospital.client-details"),
            key: "hospital-details",
          },
        ];
  }
};
export const addbreadCrumbItems = (state, enterprise, role, firmType, firmMode) => {
  if(firmMode==="projects"){
    return [
      {
        text: t("hospital.projects"),
        key: "projects",
        href: AuthRoutes.PROJECTLIST,
      },
      {
        text: "Add Project",
        key: "add-project",
      },
    ];
  }else return [
  {
    text: enterprise
      ? t("hospital.hospitals")
      : role === USERTYPES.ADMIN
      ? t("hospital.firms")
      : t("hospital.clients"),
    key: "hospital",
    href:
      role === USERTYPES.ADMIN ? AuthRoutes.FIRMLIST : AuthRoutes.CLIENTLIST,
  },
  {
    text:
      firmType === "Teleradiology Centre"
        ? t("hospital.add-trc")
        : firmType === "Imaging Centre"
        ? t("hospital.add-ic")
        : t("hospital.add-hospital"),
    key: "add-hospital",
  },
]};

export const passwordProtectedOptions = () => [
  {
    key: true,
    text: t("hospital.yes"),
  },
  {
    key: false,
    text: t("hospital.no"),
  },
];

export const actionOptions = () => [
  {
    key: true,
    text: t("hospital.active"),
  },
  {
    key: false,
    text: t("hospital.inactive"),
  },
];

export const contactCustomValidation = (
  values,
  actions,
  field,
  scrollSection,
  document
) => {
  let flag = false;
  let errorSection = "";
  if (
    values.name != "" ||
    values.email != "" ||
    values.type != "" ||
    values.mobile != "" ||
    values.landline != ""
  ) {
    if (values.name == "") {
      actions.setFieldError(field + ".name", StringLiterals.nameEmpty);

      errorSection = scrollSection;
      flag = true;
    }
    if (values.email == "") {
      actions.setFieldError(field + ".email", StringLiterals.emailEmpty);
      errorSection = scrollSection;
      flag = true;
    } else {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      if (!regex.test(values.email)) {
        actions.setFieldError(field + ".email", StringLiterals.emailInvalid);
        flag = true;
        errorSection = scrollSection;
      }
    }
    if (values.type == "") {
      actions.setFieldError(field + ".type", StringLiterals.typeEmpty);
      errorSection = scrollSection;
      flag = true;
    }
  }
  if (flag) {
    const element = document.getElementById(errorSection);
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  return flag;
};

export const tabStatusInitialValue = {
  tab1Status: { value: "Info", color: "#FF9900" },
  tab2Status: { value: "Info", color: "#FF9900" },
  tab3Status: { value: "Info", color: "#FF9900" },
  tab4Status: { value: "Info", color: "#FF9900" },
  tab5Status: { value: "Info", color: "#FF9900" },
  tab6Status: { value: "Info", color: "#FF9900" },
  tab7Status: { value: "Info", color: "#FF9900" },
  tab8Status: { value: "Info", color: "#FF9900" },
  tab9Status: { value: "Info", color: "#FF9900" },
  tab10Status: { value: "Info", color: "#FF9900" },
  tab11Status: { value: "Info", color: "#FF9900" },
  tab12Status: { value: "Info", color: "#FF9900" },
  tab13Status: { value: "Info", color: "#FF9900" },
  tab14Status: { value: "Info", color: "#FF9900" },
  tab15Status: { value: "Info", color: "#FF9900" },
  tab16Status: { value: "Info", color: "#FF9900" },
  tab17Status: { value: "Info", color: "#FF9900" },
  tab18Status: { value: "Info", color: "#FF9900" },
};

export const editTabStatusInitialIcon = {
  tab1Status: { value: "Completed", color: "green" },
  tab2Status: { value: "Completed", color: "green" },
  tab3Status: { value: "Completed", color: "green" },
  tab4Status: { value: "Completed", color: "green" },
  tab5Status: { value: "Completed", color: "green" },
  tab6Status: { value: "Completed", color: "green" },
  tab7Status: { value: "Completed", color: "green" },
  tab8Status: { value: "Completed", color: "green" },
  tab9Status: { value: "Completed", color: "green" },
  tab10Status: { value: "Completed", color: "green" },
  tab11Status: { value: "Completed", color: "green" },
  tab12Status: { value: "Completed", color: "green" },
  tab13Status: { value: "Completed", color: "green" },
  tab14Status: { value: "Completed", color: "green" },
  tab15Status: { value: "Completed", color: "green" },
  tab16Status: { value: "Completed", color: "green" },
  tab17Status: { value: "Info", color: "#FF9900" },
  tab18Status: { value: "Completed", color: "green" },
};

export const editNewTabStatusInitialIcon = {
  tab1Status: { value: "Completed", color: "green" },
  tab2Status: { value: "Completed", color: "green" },
  tab3Status: { value: "Completed", color: "green" },
  tab4Status: { value: "Completed", color: "green" },
  tab5Status: { value: "Completed", color: "green" },
  tab6Status: { value: "Completed", color: "green" },
  tab7Status: { value: "Completed", color: "green" },
  tab8Status: { value: "Completed", color: "green" },
  tab9Status: { value: "Completed", color: "green" },
  tab10Status: { value: "Completed", color: "green" },
  tab11Status: { value: "Completed", color: "green" },
  tab12Status: { value: "Completed", color: "green" },
  tab13Status: { value: "Completed", color: "green" },
  tab14Status: { value: "Completed", color: "green" },
  tab15Status: { value: "Completed", color: "green" },
  tab16Status: { value: "Completed", color: "green" },
  tab17Status: { value: "Completed", color: "green" },
  tab18Status: { value: "Completed", color: "green" },
};

export const emptyData = {
  name: { error: false, msg: "Name is required" },
  email: { error: false, msg: "Email is required" },
  type: { error: false, msg: "Type is required" },
  mobile: { error: false, msg: "Mobile is required" },
  landline: { error: false, msg: "Landline is required" },
};

export const initContact1Validation = {
  contact1: emptyData,
  errorState: true,
};

export const initContact2Validation = {
  contact2: emptyData,
  errorState: false,
};

export const initContact3Validation = {
  contact3: emptyData,
  errorState: false,
};

export const initErrorContactState = {
  hospitalDetails: {
    name: { error: false, msg: StringLiterals.nameEmpty },
    address: { error: false, msg: StringLiterals.addressEmpty },
    country: { error: false, msg: StringLiterals.addressEmpty },
    state: { error: false, msg: StringLiterals.addressEmpty },
    city: { error: false, msg: StringLiterals.addressEmpty },
    customerSupportNumber:{error:false,msg:StringLiterals.invalidCustomerSupportNumber},
    priorityCount: { error: false, msg: StringLiterals.priority_study_value },
  },
  contact1: {
    name: { error: false, msg: StringLiterals.nameEmpty },
    email: { error: false, msg: StringLiterals.emailEmpty },
    type: { error: false, msg: StringLiterals.typeEmpty },
    mobile: { error: false, msg: StringLiterals.mobileEmpty },
    landline: { error: false, msg: StringLiterals.landlineEmpty },
    errorState: true,
  },
  contact2: {
    name: { error: false, msg: StringLiterals.nameEmpty },
    email: { error: false, msg: StringLiterals.emailEmpty },
    type: { error: false, msg: StringLiterals.typeEmpty },
    mobile: { error: false, msg: StringLiterals.mobileEmpty },
    landline: { error: false, msg: StringLiterals.landlineEmpty },
    errorState: false,
  },
  contact3: {
    name: { error: false, msg: StringLiterals.nameEmpty },
    email: { error: false, msg: StringLiterals.emailEmpty },
    type: { error: false, msg: StringLiterals.typeEmpty },
    mobile: { error: false, msg: StringLiterals.mobileEmpty },
    landline: { error: false, msg: StringLiterals.landlineEmpty },
    errorState: false,
  },
  contactChannel: {
    error: false,
    msg: "" ,
    notificationEmail: { error: false, msg: "" },
    whatsappNumber: { error: false, msg: "" }
  },
  customerSupportNumber:{
    error:false,
    msg:" ",
  },
  settings: {
    autoAssignModalityIds: {
      error: false,
      msg: "Please select at least one modality from the dropdown.",
    },
    modalityIds: {
      error: false,
      msg: "Please select at least one modality for QC from the dropdown.",
    },
    historyModalityIds: {
      error: false,
      msg: "Please select at least one modality for history available from the dropdown.",
    },
    accountWarning: {
      erorr: false,
      msg: "Account warning cannot be greater than 1000 characters.",
    },
    studyLinkExpiryTime: {
      error: false,
      msg: "Study link validity time is invalid. It should be in integers only.",
    },
    qrLinkExpiryTime: {
      error: false,
      msg: "QR link validity time is invalid. It should be in integers only.",
    },
    reportLinkExpiryTime: {
      error: false,
      msg: "Report link validity time is invalid.",
    },
    printDisclaimerText: {
      error: false,
      msg: "Disclaimer cannot be empty.",
    },
    addendumDisclaimerText: {
      error: false,
      msg: "Disclaimer cannot be empty.",
    },
    signature2Dto: {
      
      signature2Text: {
        error: false,
        msg: "Signature cannot be greater than 50 characters.",
      }
      
    },
    signature3Dto: {
      
      signature3Text: {
        error: false,
        msg: "Signature cannot be greater than 50 characters.",
      }
      
    },
    unassignmentModalityIds: {
      error: false,
      msg: "Please select at least one modality for unassignment service from the dropdown.",
    },
    masterClientComm: {
      error: false,
      msg: ""
    }
   
  },
    otherReportSettings: {
    studyLinkExpiryTime: {
      error: false,
      msg: "Study link validity time is invalid. It should be in integers only.",
    },
    reportLinkExpiryTime: {
      error: false,
      msg: "Report link validity time is invalid.",
    },
    addendumDisclaimerText: {
      error: false,
      msg: "Disclaimer cannot be empty.",
    },
    signature2Dto: {
      signature2Text: {
        error: false,
        msg: "Signature cannot be greater than 50 characters.",
      }
    },
    signature3Dto: {
      signature3Text: {
        error: false,
        msg: "Signature cannot be greater than 50 characters.",
      }
    },
    emailFormat: {
      error: false,
      msg: "At least one email format (PDF or DOCX) must be selected.",
    },
  },
  configureSettings: {
    priorityCount: { error: false, msg: StringLiterals.priority_study_value },
    printDisclaimerText: {
      error: false,
      msg: "Disclaimer cannot be empty.",
    },
    studyLinkExpiryTime: {
      error: false,
      msg: "Study link validity time is invalid. It should be in integers only.",
    },
    accountWarning: {
      erorr: false,
      msg: "Account warning cannot be greater than 1000 characters.",
    },
  },
  otherSettings: {
    modalityIds: {
      error: false,
      msg: "Please select at least one modality for QC from the dropdown.",
    },
    historyModalityIds: {
      error: false,
      msg: "Please select at least one modality from the dropdown.",
    },
     unassignmentModalityIds: {
      error: false,
      msg: "Please select at least one modality for unassignment service from the dropdown.",
    },
      signature2Text: { error: false, msg: "" },  // ← ADD
      signature3Text: { error: false, msg: "" }   // ← ADD
  },
  autoAssignSettings: {
    autoAssignModalityIds: {
      error: false,
      msg: "Please select at least one modality from the dropdown.",
    },
    pediatricModalityIds: {
      error: false,
      msg: "Please select at least one modality from the dropdown.",
    },
  },
  pacsNodeConfig: {
    error: false, 
    msg: StringLiterals.nameEmpty,
  },
  tabStatusInitialValue: {
    tab1Status: { value: "Info", color: "#FF9900" },
    tab2Status: { value: "Info", color: "#FF9900" },
    tab3Status: { value: "Info", color: "#FF9900" },
    tab4Status: { value: "Info", color: "#FF9900" },
    tab5Status: { value: "Info", color: "#FF9900" },
    tab6Status: { value: "Info", color: "#FF9900" },
    tab7Status: { value: "Info", color: "#FF9900" },
    tab8Status: { value: "Info", color: "#FF9900" },
    tab9Status: { value: "Info", color: "#FF9900" },
    tab10Status: { value: "Info", color: "#FF9900" },
    tab11Status: { value: "Info", color: "#FF9900" },
    tab12Status: { value: "Info", color: "#FF9900" },
    tab13Status: { value: "Info", color: "#FF9900" },
    tab14Status: { value: "Info", color: "#FF9900" },
    tab15Status: { value: "Info", color: "#FF9900" },
    tab16Status: { value: "Info", color: "#FF9900" },
    tab17Status: { value: "Info", color: "#FF9900" },
    tab18Status: { value: "Info", color: "#FF9900" },
  },
  errorState: true,
};

export const initResetValues = {
  hospitalDetails: {
    name: { error: false, msg: StringLiterals.nameEmpty },
    address: { error: false, msg: StringLiterals.addressEmpty },
    country: { error: false, msg: StringLiterals.addressEmpty },
    state: { error: false, msg: StringLiterals.addressEmpty },
    city: { error: false, msg: StringLiterals.addressEmpty },
    priorityStudies: { error: false, msg: StringLiterals.priority_study_value },
  },
  contact1: {
    name: { error: false, msg: StringLiterals.nameEmpty },
    email: { error: false, msg: StringLiterals.emailEmpty },
    type: { error: false, msg: StringLiterals.typeEmpty },
    mobile: { error: false, msg: StringLiterals.mobileEmpty },
    landline: { error: false, msg: StringLiterals.landlineEmpty },
    errorState: true,
  },
  contact2: {
    name: { error: false, msg: StringLiterals.nameEmpty },
    email: { error: false, msg: StringLiterals.emailEmpty },
    type: { error: false, msg: StringLiterals.typeEmpty },
    mobile: { error: false, msg: StringLiterals.mobileEmpty },
    landline: { error: false, msg: StringLiterals.landlineEmpty },
    errorState: false,
  },
  contact3: {
    name: { error: false, msg: StringLiterals.nameEmpty },
    email: { error: false, msg: StringLiterals.emailEmpty },
    type: { error: false, msg: StringLiterals.typeEmpty },
    mobile: { error: false, msg: StringLiterals.mobileEmpty },
    landline: { error: false, msg: StringLiterals.landlineEmpty },
    errorState: false,
  },
  settings: {
    autoAssignModalityIds: {
      error: false,
      msg: "Please select at least one modality from the dropdown.",
    },
    modalityIds: {
      error: false,
      msg: "Please select at least one modality for QC from the dropdown.",
    },
    historyModalityIds: {
      error: false,
      msg: "Please select at least one modality for history available from the dropdown.",
    },
    accountWarning: {
      erorr: false,
      msg: "Account warning cannot be greater than 1000 characters.",
    },
    studyLinkExpiryTime: {
      error: false,
      msg: "Study link validity time is invalid. It should be in integers only.",
    },
    qrLinkExpiryTime: {
      error: false,
      msg: "QR link validity time is invalid. It should be in integers only.",
    },
    reportLinkExpiryTime: {
      error: false,
      msg: "Report link validity time is invalid.",
    },
    printDisclaimerText: {
      error: false,
      msg: "Disclaimer cannot be empty.",
    },
  },
  otherReportSettings: {
    studyLinkExpiryTime: {
      error: false,
      msg: "Study link validity time is invalid. It should be in integers only.",
    },
    reportLinkExpiryTime: {
      error: false,
      msg: "Report link validity time is invalid.",
    },
    addendumDisclaimerText: {
      error: false,
      msg: "Disclaimer cannot be empty.",
    },
    signature2Dto: {
      signature2Text: {
        error: false,
        msg: "Signature cannot be greater than 50 characters.",
      }
    },
    signature3Dto: {
      signature3Text: {
        error: false,
        msg: "Signature cannot be greater than 50 characters.",
      }
    },
  },
  configureSettings: {
    priorityCount: { error: false, msg: StringLiterals.priority_study_value },
    printDisclaimerText: {
      error: false,
      msg: "Disclaimer cannot be empty.",
    },
    accountWarning: {
      erorr: false,
      msg: "Account warning cannot be greater than 1000 characters.",
    },
  },
  otherSettings: {
    modalityIds: {
      error: false,
      msg: "Please select at least one modality for QC from the dropdown.",
    },
    historyModalityIds: {
      error: false,
      msg: "Please select at least one modality from the dropdown.",
    },
     unassignmentModalityIds: {
      error: false,
      msg: "Please select at least one modality for unassignment service from the dropdown.",
    },
  },
  autoAssignSettings: {
    autoAssignModalityIds: {
      error: false,
      msg: "Please select at least one modality from the dropdown.",
    },
    pediatricModalityIds: {
      error: false,
      msg: "Please select at least one modality from the dropdown.",
    },
  },
  pacsNodeConfig: {
    error: false, 
    msg: StringLiterals.nameEmpty 
  },
  tabStatusInitialValue: {
    tab1Status: { value: "Info", color: "#FF9900" },
    tab2Status: { value: "Info", color: "#FF9900" },
    tab3Status: { value: "Info", color: "#FF9900" },
    tab4Status: { value: "Info", color: "#FF9900" },
    tab5Status: { value: "Info", color: "#FF9900" },
    tab6Status: { value: "Info", color: "#FF9900" },
    tab7Status: { value: "Info", color: "#FF9900" },
    tab8Status: { value: "Info", color: "#FF9900" },
    tab9Status: { value: "Info", color: "#FF9900" },
    tab10Status: { value: "Info", color: "#FF9900" },
    tab11Status: { value: "Info", color: "#FF9900" },
    tab12Status: { value: "Info", color: "#FF9900" },
    tab13Status: { value: "Info", color: "#FF9900" },
    tab14Status: { value: "Info", color: "#FF9900" },
    tab15Status: { value: "Info", color: "#FF9900" },
    tab16Status: { value: "Info", color: "#FF9900" },
    tab17Status: { value: "Info", color: "#FF9900" },
    tab18Status: { value: "Info", color: "#FF9900" },
  },
  errorState: true,
};
